import { Action, createReducer, on } from '@ngrx/store';
import * as StrategyActions from '../strategy.actions';
import * as AppRootActions from '@app/app.actions';
import * as ProfileActions from '@profile/profile.actions';

import { StrategyCHState } from '@shared/models/Strategy';

export const STRATEGY_CH_REDUCER_FEATURE_KEY = 'strategyCH';

export const initialState: StrategyCHState = {
  isInitialized: false,
  riskSurveyQuestions: []
};

const strategyCHReducer = createReducer(
  initialState,
  on(StrategyActions.setCHRiskQuestions, (state, action) => ({
    ...state,
    isInitialized: true,
    riskSurveyQuestions: action.riskSurveyQuestions
  })),
  on(AppRootActions.switchAccount, ProfileActions.logout, () => ({ ...initialState }))
);

export function reducer(state: StrategyCHState, action: Action): StrategyCHState {
  return strategyCHReducer(state, action);
}
